<template>
  <div v-if="!disabled" class="form-floating" :class="'mb-'+mb">
    <input
        class="form-control form-control-solid"
        autocomplete="off"
        :placeholder="placeholder"
        :disabled="disabled"
        :value="modelValue"
        :class="hasError ? 'is-invalid' : ''"
        :required="required"
        :type="type"
        :min="min"
        :name="name"
        :id=id
        @input="updateValue"
        @change="updateValue"
    >
    <label :for=id :class="{ required: required }" v-html="placeholder"></label>
    <slot></slot>
  </div>
  <disabled-field v-else :value="modelValue" :mb="mb" :placeholder="placeholder" :required="required"/>
</template>

<script>
import DisabledField from '@/components/Fields/DisabledField'

export default {
  name: 'InputField',
  components: {DisabledField},
  props: {
    placeholder: null,
    modelValue: '',
    required: false,
    hasError: false,
    disabled: null,
    class: null,
    type: null,
    min: null,
    name: null,
    mb:null,
    id:null
  },
  methods: {
    updateValue(event) {
      let value = event.target.value
      if (
        this.min &&
        value &&
        (this.type === 'date' || this.type === 'datetime-local') &&
        value < this.min
      ) {
        value = this.min
        event.target.value = value
      }
      this.$emit('update:modelValue', value)
    }
  }
}
</script>

<style scoped>

</style>